import colors from '../colors';
import baseTheme from '../baseTheme';
var MuiAlert = {
    root: {
        borderWidth: 1,
        borderStyle: 'solid',
        lineHeight: 1.5,
        padding: '9px 16px 8px',
        alignContent: 'center',
        alignItems: 'flex-start',
    },
    standardWarning: {
        backgroundColor: colors.yellow[50],
        color: colors.yellow.A700,
        borderColor: colors.yellow[500],
        '& $icon': {
            color: colors.yellow.A700,
            borderColor: colors.yellow[500],
        },
    },
    standardInfo: {
        backgroundColor: colors.blue[50],
        color: colors.blue[800],
        borderColor: colors.blue[500],
        '& $icon': {
            color: colors.blue[800],
            borderColor: colors.blue[500],
        },
    },
    standardSuccess: {
        backgroundColor: colors.green[50],
        color: colors.green.A700,
        borderColor: colors.green[500],
        '& $icon': {
            color: colors.green.A700,
            borderColor: colors.green[500],
        },
    },
    standardError: {
        backgroundColor: colors.orange[50],
        color: colors.orange.A700,
        borderColor: colors.orange[200],
        '& $icon': {
            color: colors.orange.A700,
            borderColor: colors.orange[200],
        },
    },
    message: {
        fontSize: baseTheme.typography.body1.fontSize,
        fontWeight: 300,
        padding: '3px 0',
    },
    icon: {
        flexShrink: 0,
        borderWidth: 1,
        borderStyle: 'solid',
        background: 'white',
        display: 'flex',
        color: 'inherit',
        width: 28,
        height: 28,
        fontSize: 22,
        fontWeight: 600,
        borderRadius: 24,
        alignContent: 'center',
        alignItems: 'center',
        justifyContent: 'center',
    },
};
export default MuiAlert;
//# sourceMappingURL=MuiAlert.js.map